import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select';
import { CalendarSelectProps } from '@/domain/termine/features/CreateTermin/shared/types/types';

export function CalendarSelectSheet({
  value,
  onChange,
  kalender,
}: CalendarSelectProps) {
  const selectedKalender = kalender.find((k) => k.id === value);
  const displayText = selectedKalender?.name;
  return (
    <div className="pb-3 h-10">
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="border-neutrals-N300 w-full">
          {displayText}
        </SelectTrigger>
        <SelectContent className="border-none overflow-visible">
          <SelectGroup>
            {kalender.map((kalenderItem) => (
              <SelectItem
                className="p-2"
                key={kalenderItem.id}
                value={kalenderItem.id}>
                <span className="text-sm font-medium">{kalenderItem.name}</span>
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}
